// extracted by mini-css-extract-plugin
export default {"container":"Header_container__Hdlyx","logo":"Header_logo__T8pyO","right":"Header_right__QScEx","menu":"Header_menu__dAlWy","tire":"Header_tire__cOY8h","bars":"Header_bars__0YKUv"};